import { gql } from 'apollo-angular';

export const NEWS_LIST = gql`
  query News($page: Int, $status: NewsStatusEnum, $audience: NewsAudienceEnum) {
    news(page: $page, status: $status, audience: $audience) {
      audience
      dateCreated
      dateUpdated
      description
      link
      newsId
      photo
      status
      subTitle
      title
      type
    }
  }
`;
